import { Injectable } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { ShareService } from './share.service';
import { StorageService } from './storage.service';

export interface GalleryEmbedOptions {
  addCover: boolean;
  allowAssetView: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class GalleryEmbedService {
  constructor(private shareService: ShareService, private storage: StorageService) {}

  async getEmbedCode(gallery: GalleryDto, options: GalleryEmbedOptions) {
    const link = await this.shareService.getShareLink(gallery, { forceSubdomain: true });
    let src = link.url + '/embed';
    if (!src.includes('?')) src += '?e';
    if (!options.addCover) src += '&hideCover=true';
    if (!options.allowAssetView) src += '&blockImageView=true';
    return `<iframe src="${src}" frameborder="0" width="100%" height="1000px" onload="setIframeComms(this)" id="${gallery.id}" scrolling="no"></iframe><script>window.addEventListener("message",e=>{if(e&&"${gallery.id}"===e.data.galleryId){var t=document.getElementById("${gallery.id}");if(e.data.hasOwnProperty("FrameHeight"))t.style.height=e.data.FrameHeight+"px";else if(e.data.hasOwnProperty("fullscreen")){var s=e.data.fullscreen;t.style.position=s?"fixed":"static",t.style.zIndex=s?"999999999":"unset",t.style.inset="0",t.style.maxHeight=s?"100%":"unset",t.style.minHeight=s?"100%":"unset"}}}),window.setIframeComms=e=>{e.contentWindow.postMessage("iframeComms","*")};</script>`;
  }

  public getEmbedPreferences(): GalleryEmbedOptions {
    return this.storage.get('embedPreferences') || { addCover: false, allowAssetView: true };
  }

  public setEmbedPreferences(options: GalleryEmbedOptions): void {
    this.storage.set('embedPreferences', options);
  }
}
